import { SafeBaseObject } from '@app/core/models/base-object.models';
import { DateTime } from 'luxon';

export class ResBkgDocument extends SafeBaseObject {
  bkgID = 0
  requestType = ''
  emailTo = ''
  process = ''
  url = ''
  blbGuid=''
  guestCopyOnly = false
  created = DateTime.local()

  fileName = ''
  constructor(data?: IReservationApiBkgDocument) {
    super();

    if (data) this.updateData(data);
  }

  override updateData(data: IReservationApiBkgDocument): void {
    this.addMangledProperty(data);

    const parts =  this.url.replace(/\\/g,'/').split('/')
    this.fileName = parts[parts.length-1]

    /* if (data.RequestTime) {
      const hour = Number(data.RequestTime.toString().substring(0, 2));
      const minute = Number(data.RequestTime.toString().substring(2));
      if (isNaN(hour) || isNaN(minute)) return

      this.requestTime = DateTime.fromObject({ minute, hour })

      if (!this.requestTime.isValid) return

      this.formattedRequestDate = DateTime.fromObject({ year: this.requestDate.year, month: this.requestDate.month, day: this.requestDate.day, hour: this.requestTime.hour, minute: this.requestTime.minute, second: this.requestTime.second }).toLocaleString(DateTime.DATETIME_SHORT)
    } */
  }
}

export interface IReservationApiBkgDocument {
  BkgID: number;
  RequestType: string;
  EmailTo: string;
  Process: string;
  URL: string;
  GuestCopyOnly: string;
  RequestDate: number;
  RequestTime: number;
}

export interface IReservationApiSearchBkgDocumentParams {
  BkgID: number;
  // SectionID: number;
  RequestType?: string;
  DateFrom?: DateTime;
  DateTo?: DateTime;
}

export interface IReservationApiCreateBkgDocumentParams {
  BkgID: number;
  SectionID: number;
  GuestRemarks?: string;
  AgencyRemarks?: string;
  AirRemarks?: string;
  DocType?: string;
  EmailTo?: string;
  EmailCC?: string;
  GuestCopyOnly?: string;
  ItineraryFlag?: string;
  Company?: string;
}
